import ReaddyForm, { type FormField } from '@/components/feature/ReaddyForm';
import SectionHeading from '@/components/base/SectionHeading';

const cooperationFields: FormField[] = [
  {
    name: 'name',
    label: '联系人',
    type: 'text',
    required: true,
    placeholder: '请填写对接人姓名',
    half: true,
    maxLength: 40,
  },
  {
    name: 'email',
    label: '联系邮箱',
    type: 'email',
    required: true,
    placeholder: '用于接收回复',
    half: true,
  },
  {
    name: 'organization',
    label: '机构或品牌名称',
    type: 'text',
    required: true,
    placeholder: '例如：某报社调查部 / 某高校公共政策研究中心',
  },
  {
    name: 'type',
    label: '合作类型',
    type: 'select',
    required: true,
    options: [
      '内容转载授权',
      '联合调查协作',
      '数据与研究合作',
      '品牌与内容共建',
      '安全技术协作',
      '其他合作意向',
    ],
  },
  {
    name: 'message',
    label: '合作说明',
    type: 'textarea',
    required: true,
    placeholder:
      '请说明合作目标、涉及的具体议题或栏目、预计启动时间，以及希望平台承担的部分。信息越具体，评估越快。',
    hint: '最多 500 字。如涉及未结案线索，请不要在此描述线索细节。',
  },
];

const directContacts = [
  { icon: 'ri-mail-send-line', label: '商务合作邮箱', value: 'business@shentong-baoliao.com' },
  { icon: 'ri-time-line', label: '回复时效', value: '工作日 2 个工作日内回复' },
  { icon: 'ri-shield-check-line', label: '保密说明', value: '申请表内容仅商务团队可见' },
];

export default function CooperationFormSection() {
  return (
    <section id="apply" className="bg-background-100 py-14 md:py-24">
      <div className="w-full px-5 md:px-8 lg:px-12">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-5">
            <SectionHeading
              kicker="Apply Now"
              title="提交合作申请"
              description="填写下表中的信息即可发起申请。如果更习惯邮件沟通，也可以直接发送到商务合作邮箱，注明同样的内容。"
            />

            <div className="mt-8 bg-background-50 border border-foreground-950/10 rounded-lg divide-y divide-foreground-950/10">
              {directContacts.map((item) => (
                <div key={item.label} className="flex items-start gap-4 p-5">
                  <span className="shrink-0 w-11 h-11 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <div className="min-w-0">
                    <p className="font-mono text-xs tracking-[0.14em] uppercase text-foreground-500">
                      {item.label}
                    </p>
                    <p className="mt-1.5 text-sm text-foreground-900 break-all">{item.value}</p>
                  </div>
                </div>
              ))}
            </div>

            <p className="mt-7 flex items-start gap-3 text-xs md:text-sm leading-relaxed bg-accent-100 text-accent-950 border border-accent-200 rounded-md px-4 py-3.5">
              <i className="ri-lightbulb-line text-lg shrink-0 mt-0.5"></i>
              <span>
                平台不接受以撤稿、修改结论为前提的合作诉求。如果你的需求涉及内容处置，建议先与法务或公关团队确认后再申请。
              </span>
            </p>
          </div>

          <div className="lg:col-span-7">
            <div className="bg-background-50 border border-foreground-950/10 rounded-lg p-6 md:p-8">
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                商务合作申请表单
              </h3>
              <p className="mt-2 text-sm text-foreground-600">
                带 <span className="text-primary-500">*</span> 的为必填项。
              </p>
              <div className="mt-6">
                <ReaddyForm
                  formId="cooperation-apply-form"
                  submitAddr="https://readdy.ai/api/form/dah87kboh653ivfvno0g"
                  fields={cooperationFields}
                  honeypotName="company_alt"
                  submitLabel="提交合作申请"
                  successText="合作申请已提交，商务团队会在 2 个工作日内通过你留下的邮箱联系你。"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}